/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partneractivestate2Inputs */

const de__field_partneractivestate2 = /** @type {(inputs: _Field_Partneractivestate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**

* @param {_Field_Partneractivestate2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_partneractivestate2 = /** @type {((inputs?: _Field_Partneractivestate2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partneractivestate2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_partneractivestate2(inputs)
});
export { _field_partneractivestate2 as "_field_partnerActiveState" }